import React from "react";
import Skeleton from "react-loading-skeleton";
import { defaultLogo } from "../../../env";

const ProjectLoadCard = () => {

  return (
    <div className="project-item loading" >
      <div className="img-wrapper ">
          <img src={defaultLogo} />
      </div>
      <div className="detail-sec">
        <div className="name-info w-100">
          <div className="name-date w-100">
            <p className="name w-100">
            <Skeleton width="100%" height="1rem" />
            </p>
            <span className="date">
            <Skeleton width="100%" height="1rem" />
            </span>
          </div>

        </div>
        <div className="owner-detail w-100">
        <Skeleton  width="100%" height="1rem" />
        </div>
      </div>
    </div>
  );
};

export default ProjectLoadCard;
